import SearchCardDTO from '@/dto/searchCardDTO';
import TopSellingDTO from '@/dto/topSellingDTO';
import {
  CarouselsResponse,
  CategoryRequest,
  Content,
  Docs,
  PlacementItem,
  PlacementItemResponse,
  RecommendedProductItem,
  RecommendedProducts,
  TopSellingProduct,
} from '@/types/algonomy';

class AlgonomyConverter {
  public convertCarouselProduct(topSelling: CarouselsResponse): CategoryRequest {
    const newTopSelling = {
      ...topSelling,
      placements: topSelling?.placements?.map(
        (placement: PlacementItem): PlacementItemResponse => ({
          ...placement,
          recommendedProducts: placement.recommendedProducts.map(
            (recommendedProductItem: RecommendedProductItem): TopSellingProduct => {
              const topSellingProduct = new TopSellingDTO(recommendedProductItem);
              return topSellingProduct.getProduct;
            },
          ),
        }),
      ),
    };
    return newTopSelling;
  }

  public convertSearchCardProducts(recommendedProducts: RecommendedProducts | null): Array<Docs | Content> | null {
    return (
      recommendedProducts?.map((recommendedProduct: RecommendedProductItem) => {
        const product = new SearchCardDTO(recommendedProduct).getRecommendedProduct;
        return product;
      }) || null
    );
  }
}

export default AlgonomyConverter;
